import styled from 'styled-components';

const DetailIconsContainer = styled.div<React.CSSProperties>``;

export default DetailIconsContainer;
